import * as React from 'react';
import ouiStyle from '@goldwasserexchange/oui-style';
import { DomH3 } from '../../../HeadingSection';
export var SanityNewsH3 = function (props) {
    var children = props.children;
    return (React.createElement(DomH3, { lineFactor: 1.1, color: ouiStyle.Constants.Colors.primary, paddingTop: ['simple', undefined, undefined, 'simple', undefined, undefined], paddingBottom: ['simple', undefined, undefined, 'none', undefined, undefined] }, children));
};
